import React from "react";
import PropTypes from "prop-types";

export const SubSectionSpaced = ({ leftLabel, rightLabel, separatorVariant = "normal", disablePb = false, disableMb = false, headerVariant = "normal", children }) => {
    return (
        <div className={`spaced-subsection ${separatorVariant === "none" ? "" : `${separatorVariant === "thick" ? "separator--thick" : "separator"}`} ${disablePb ? "disable-pb" : ""} ${disableMb ? "disable-mb" : ""}`}>
            <div className="row">
                <div className="column">
                    <div className="spaced-subsection__header">
                        <Header headerVariant={headerVariant}>{leftLabel}</Header>
                        {rightLabel && <Header headerVariant={headerVariant}>{rightLabel}</Header>}
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
};

export const SubSectionSpacedInfo = ({ children }) => {
    return <div className="spaced-subsection__info">{children}</div>;
};

SubSectionSpaced.propTypes = {
    leftLabel: PropTypes.string.isRequired,
    rightLabel: PropTypes.string,
    separatorVariant: PropTypes.oneOf(["thick", "normal", "none"]),
    disablePb: PropTypes.bool,
    disableMb: PropTypes.bool,
    headerVariant: PropTypes.oneOf(["small", "normal"]),
};

const Header = ({ headerVariant, children }) => {
    if (headerVariant === "small") {
        return <h3>{children}</h3>;
    }

    return <h2>{children}</h2>;
};
